export var DataExportStatus;
(function (DataExportStatus) {
    DataExportStatus["Pending"] = "Pending";
    DataExportStatus["Processing"] = "Processing";
    DataExportStatus["Completed"] = "Completed";
    DataExportStatus["Failed"] = "Failed";
})(DataExportStatus || (DataExportStatus = {}));
export const dataExportKinds = ["dataDownload", "activitiesReport"];
//# sourceMappingURL=data-export.js.map